import type { JssStyle } from 'jss';
import type { WebLegacyWidgetEntity } from '@web/types';
import type { CodeWidgetData } from '@web/widgets/code/type';

export function getStyles(widget: WebLegacyWidgetEntity<CodeWidgetData>): JssStyle {
    return {
        imgWrapper: {
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '200px',
            background: '#F8FDFE',
        },
        text: {
            color: '#023346',
            fontSize: '16px',
            textAlign: 'center',
            padding: '0 10px',
        },
    };
}
